import React from 'react';
import type { FunctionComponent } from 'react';
import { longDateHandler } from '@utils';

interface ExpiredStatusProps {
	expiredOnUtc: string;
}

export const ExpiredStatus: FunctionComponent<ExpiredStatusProps> = ({ expiredOnUtc }) => {
	return (
		<div className="account-status-tooltip">
			<p className="account-status-content-row account-status-content-row--bold">Expired on:</p>
			<p className="account-status-content-row">{longDateHandler(expiredOnUtc)}</p>
		</div>
	);
};
